import React from 'react';

import * as api from '@gitbook/api-client';
import { useSafeContext } from '@gitbook/util-react-hooks';

export type HomeContextType = {
    organization: api.Organization;
    hasNewUseCases: boolean;
};

export const HomeContext = React.createContext<HomeContextType | null>(null);

export function HomeContextProvider(props: {
    children: React.ReactNode;
    organization: api.Organization;
}) {
    const { children, organization } = props;

    const hasNewUseCases = organization.useCase
        ? [
              api.OrganizationUseCase.InternalDocs,
              api.OrganizationUseCase.DocsSite,
              api.OrganizationUseCase.AudienceControlledSite,
          ].includes(organization.useCase)
        : false;

    const value = React.useMemo(
        () => ({
            organization,
            hasNewUseCases,
        }),
        [organization, hasNewUseCases]
    );

    return <HomeContext.Provider value={value}>{children}</HomeContext.Provider>;
}

export function useHomeContext() {
    return useSafeContext(HomeContext, 'useHomeContext must be used within a HomeContextProvider');
}
